<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              @if (sessionConsultant) {
                <div class="row">
                  <div class="d-flex justify-content-center">
                    <pr-input-radio
                      [derrors]="derrors"
                      formControlName="paymentFrequency"
                      direction="column"
                      [isDefault]="false"
                      columns="2"
                      [options]="options"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              }
              <!-- table -->
              @if (table.length) {
                <div class="d-flex receipt">
                  <div class="col-md-12 product-list-block">
                    <h5>Détail de votre offre</h5>
                    @for (row of table; track row) {
                      <div class="d-flex product">
                        <div class="product-name">
                          {{
                            row?.label === 'Bien supplémentaire'
                              ? subscriptionProduct?.parameters
                                  ?.additionalPropertyNumber > 1
                                ? subscriptionProduct?.parameters
                                    ?.additionalPropertyNumber +
                                  ' Biens supplémentaires'
                                : subscriptionProduct?.parameters
                                    ?.additionalPropertyNumber +
                                  ' Bien supplémentaire'
                              : row?.label
                          }}
                        </div>
                        <div class="product-price">
                          <p>
                            <span class="price">
                              {{
                                product
                                  ?.get('parameters')
                                  ?.get('paymentFrequency')?.value ===
                                'ANNUALLY_PAYMENT'
                                  ? row?.label === 'Bien supplémentaire'
                                    ? subscriptionProduct?.parameters
                                        ?.additionalPropertyTotal
                                    : row?.yearlyPrice
                                  : row?.label === 'Bien supplémentaire'
                                    ? row?.monthlyPrice *
                                      subscriptionProduct?.parameters
                                        ?.additionalPropertyNumber
                                    : row?.oneTimePayment
                                      ? row?.yearlyPrice
                                      : row?.monthlyPrice
                              }}€
                            </span>
                            {{
                              product
                                ?.get('parameters')
                                ?.get('paymentFrequency')?.value ===
                                'MONTHLY_PAYMENT' && !row?.oneTimePayment
                                ? 'TTC/mois'
                                : 'TTC'
                            }}
                          </p>
                        </div>
                      </div>
                    }
                    @if (subscriptionProduct?.parameters?.tradeDiscount) {
                      <div class="d-flex product">
                        <div class="product-name">Remise commercial</div>
                        <div class="product-price">
                          <p>
                            <span class="price">
                              -{{
                                subscriptionProduct?.parameters?.tradeDiscount
                              }}€
                            </span>
                          </p>
                        </div>
                      </div>
                    }
                    @if (
                      product?.get('parameters')?.get('paymentFrequency')
                        ?.value === 'MONTHLY_PAYMENT'
                    ) {
                      <div class="d-flex total-subscription">
                        <div class="total-subscription-name">
                          <p>TOTAL ANNUEL</p>
                        </div>
                        <div class="total-subscription-price">
                          <p>
                            <span class="price">
                              {{ getFixedDecimal(monthlyTotalTTC) || 0 }}€
                            </span>
                            TTC
                          </p>
                        </div>
                      </div>
                    }
                  </div>
                  <div class="col-md-12 product-payment-block">
                    <h5>Votre facturation</h5>
                    @if (
                      product?.get('parameters')?.get('paymentFrequency')
                        ?.value === 'MONTHLY_PAYMENT'
                    ) {
                      <div class="monthly-payment-block">
                        @if (totalAmountForMonth !== 0) {
                          <div class="monthly-payment">
                            <p>
                              <span class="monthly-payment-value"
                                >{{
                                  getFixedDecimal(totalAmountForMonth)
                                }}€</span
                              >
                              TTC/mois sur {{ monthsToPay?.length }} mois
                            </p>
                            <div class="monthly-payment-details">
                              <ul>
                                @for (row of table; track row) {
                                  @if (!isOneTimePayment(row)) {
                                    <li>
                                      {{
                                        row?.label === 'Bien supplémentaire'
                                          ? getAdditionnalPropertyLabelForMonth(
                                              row
                                            )
                                          : row?.label +
                                            ' = ' +
                                            row?.monthlyPrice +
                                            '€ TTC/mois'
                                      }}
                                    </li>
                                  }
                                }
                                @if (extraMonthToPay > 0) {
                                  <li>
                                    {{
                                      '+ ' +
                                        extraMonthToPay +
                                        ' mensualités complémentaires réparties sur ' +
                                        monthsToPay?.length +
                                        ' mois'
                                    }}
                                  </li>
                                }
                              </ul>
                            </div>
                          </div>
                        }
                        @if (remainderPayment > 0) {
                          <div class="remainder-payment">
                            <p>
                              <span class="monthly-remainder-payment-value">
                                {{
                                  (totalAmountForMonth != 0 ? '+ ' : '') +
                                    remainderPayment
                                }}€
                              </span>
                              TTC au 1er versement
                            </p>
                            @if (remainderPayment == 0) {
                              <p class="remainder-payment-on-one-time">
                                À régler en une seule fois
                              </p>
                            }
                          </div>
                          @if (
                            oneTimePaymentItems.length > 0 &&
                            remainderPayment > 0
                          ) {
                            <ul>
                              @for (
                                product of oneTimePaymentItems;
                                track product
                              ) {
                                <li>
                                  {{
                                    product?.label +
                                      ' = ' +
                                      product?.annuallyPriceTTC
                                  }}€ TTC
                                </li>
                              }
                            </ul>
                          }
                        }
                      </div>
                    }
                    @if (
                      product?.get('parameters')?.get('paymentFrequency')
                        ?.value === 'ANNUALLY_PAYMENT'
                    ) {
                      <div class="annually-payment-block">
                        <div class="annually-payment">
                          <p>
                            <span class="annually-payment-value"
                              >{{ annualyTotalTTC }}€</span
                            >
                            TTC
                          </p>
                          <p>À régler en une seule fois</p>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
